import React, { useState, useEffect, useRef } from "react";
import ReactGA from 'react-ga';

import '../assets/styles/App.scss';

function MoreInfo(props) {

    const [isOpen, setIsOpen] = useState(false);
    const [contentReady, setContentReady] = useState(false);
    const [text, setText] = useState(false);

    const node = useRef();

    const openMessage = () => {
        setIsOpen(true);
        setContentReady(true);
        setTimeout(function () { setText(true); }, 150);
        
       
    }
    const closeMessage = () => {
        setIsOpen(false);
        setContentReady(false);
        setTimeout(function () { setText(false); }, 150);
        
    }

    const handleMessage = () => {
        ReactGA.event({
            category: 'Info',
            action: 'Message',
            label: 'Read the pop-up message',
            value: 1
        });
    }

    const combined = () => {
        openMessage();
        handleMessage();
    }

    const handleBlur = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        // outside click 
        else {
            closeMessage();
        }
    };
    useEffect(() => {

        // add when mounted
        document.addEventListener("mousedown", handleBlur);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener("mousedown", handleBlur);
        };
    });


    return (
        <div id="moreInfoComponent">
            
            <div ref={node} className={isOpen ? "open" : ""}>
                {contentReady ? <> 
                <div className="innerMessage" onBlur={handleBlur}>
                <button aria-label={props.ariaLabel} onClick={closeMessage} className="eMedium medium uppercase bt-noir">{isOpen ? 'X' : ''}</button>
                    <div className="moreInfoContainer" id="moreInfoContainer">
                        {text ? <div className={props.contentClass} dangerouslySetInnerHTML={{ __html: props.content }}></div> : null}
                    </div></div></> : ''}
            </div>
            <span className={props.class} onClick={combined}>{isOpen ? props.close : props.more}</span>
        </div>
    )
}

export default MoreInfo;